var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "31px",
    viewBox: "0 0 27 31",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Account")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#585097",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.359684, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.705087414,28.9968419 C0.705087414,22.2521449 6.31815835,16.7830634 13.2435771,16.7830634 C20.1689959,16.7830634 25.7820668,22.2521449 25.7820668,28.9968419",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9802966,8.68765152 C20.9802966,13.1060102 17.3989607,16.6876515 12.980979,16.6876515 C8.5616324,16.6876515 4.98029657,13.1060102 4.98029657,8.68765152 C4.98029657,4.26929287 8.5616324,0.687651515 12.980979,0.687651515 C17.3989607,0.687651515 20.9802966,4.26929287 20.9802966,8.68765152 Z",
    id: "Stroke-3"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.77984506.svg";
export { ForwardRef as ReactComponent };